import { render, staticRenderFns } from "./TempConfigSchema.vue?vue&type=template&id=5e382042&scoped=true"
import script from "./TempConfigSchema.vue?vue&type=script&lang=js"
export * from "./TempConfigSchema.vue?vue&type=script&lang=js"
import style0 from "./TempConfigSchema.vue?vue&type=style&index=0&id=5e382042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e382042",
  null
  
)

export default component.exports